import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { HierarchicalData } from '@app/assessments-investigation/assessment-relation-graph/assesment-relation-graph.interface';
import {
  GetPatronData,
  GetPatronGraphDataItem,
  GetPatronGraphResponse,
  GetPatronResponse,
  PatronService,
} from '@app/services/patron.service';
import { forkJoin, Subject } from 'rxjs';
import { filter, finalize, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { PatronGraphSidePanelMode } from '../patron-graph-side-panel/patron-graph-side-panel.component';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
  standalone: false,
  selector: 'app-patron-graph-page',
  styleUrls: ['./patron-graph-page.component.css'],
  templateUrl: './patron-graph-page.component.html',
  animations: [
    trigger('panelState', [
      state('maximized', style({ width: '100%' })),
      state(
        'default',
        style({
          width: '50%',
        }),
      ),
      state(
        'minimized',
        style({
          width: '40px',
        }),
      ),
      transition('default <=> minimized', [animate('300ms cubic-bezier(0.4,0.0,0.2,1)')]),
      transition('default <=> maximized', [animate('300ms cubic-bezier(0.4,0.0,0.2,1)')]),
      transition('minimized <=> maximized', [animate('300ms cubic-bezier(0.4,0.0,0.2,1)')]),
    ]),
  ],
})
export class PatronGraphPageComponent implements OnInit {
  id: string;
  hierarchicalData: HierarchicalData<any> | null = null;
  isLoading = true;
  patron: GetPatronData | null = null;
  selectedApi: GetPatronGraphDataItem | null = null;
  sidePanelMode: PatronGraphSidePanelMode = 'default';
  private _destroy$ = new Subject<void>();

  constructor(private route: ActivatedRoute, private patronService: PatronService) {}

  ngOnInit(): void {
    this.subscribeToData();
  }

  subscribeToData() {
    this.route.paramMap
      .pipe(
        map((params: ParamMap) => params.get('id')),
        filter((id: string) => id !== null),
        tap(() => {
          this.isLoading = true;
        }),
        switchMap((id: string) => forkJoin([this.patronService.getPatron(id), this.patronService.getPatronGraph(id)])),
        finalize(() => {
          this.isLoading = false;
        }),
        takeUntil(this._destroy$),
      )
      .subscribe(([patronResponse, graphResponse]: [GetPatronResponse, GetPatronGraphResponse]) => {
        this.patron = patronResponse.data;
        this.hierarchicalData = buildHierarchicalData(patronResponse.data, graphResponse.data);
        this.isLoading = false;
      });
  }

  onNodeClick(node: GetPatronGraphDataItem): void {
    this.selectedApi = node;
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}

function buildHierarchicalData(patron: GetPatronData, graph: GetPatronGraphDataItem[]): HierarchicalData<any> {
  return {
    name: patron.name,
    children: graph,
  };
}
